module.exports = __webpack_public_path__ + "static/media/Univers-bold.9899a813.woff";